import { useMemo } from 'react'

import useAxios from '../../../../../hooks/useAxios'
import { ICostSummaryResponse, IReportFilter } from '../types'

// ดึงยอดรวมค่าใช้จ่าย TikTok จาก API ที่ aggregate ให้แล้ว (total + แยกรายวัน)
// - ไม่เลือกร้าน → distributionType=tiktok (ทุกร้าน)
// - เลือกร้าน → ref=shopId (เจาะ distribution.ref)
// ไม่ paginate → ไม่มีข้อจำกัดจำนวนรายการเหมือนตอนดึงผ่าน /costs
export const useTiktokCosts = (filter: IReportFilter) => {
  const { data, isLoading, error } = useAxios<ICostSummaryResponse>({
    method: 'GET',
    url: '/costs/summary',
    params: {
      startDate: filter.startDate,
      endDate: filter.endDate,
      distributionType: 'tiktok',
      ...(filter.shopId ? { ref: filter.shopId } : {}),
    },
  })

  const costTotal = data?.total ?? 0

  const costByDate = useMemo(() => {
    const map: Record<string, number> = {}
    const rows = data?.byDate ?? []
    rows.forEach((item) => {
      map[item.date] = item.amount
    })
    return map
  }, [data])

  return { costTotal, costByDate, isLoading, error }
}
